if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.gestureStartX = 0;
        this.gestureStartY = 0;

        const container = this.querySelector('[role="document"]');

        container?.addEventListener(
          'pointerdown',
          (event) => {
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            if (event.target.closest('.velora-modal-nav')) return;
            this.gestureStartX = event.clientX;
            this.gestureStartY = event.clientY;
          },
          { passive: true }
        );

        container?.addEventListener(
          'pointerup',
          (event) => {
            if (!this.gestureStartX && !this.gestureStartY) return;
            const deltaX = event.clientX - this.gestureStartX;
            const deltaY = event.clientY - this.gestureStartY;
            this.gestureStartX = 0;
            this.gestureStartY = 0;

            if (Math.abs(deltaX) < 55 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
            this.navigateMedia(deltaX < 0 ? 1 : -1);
          },
          { passive: true }
        );

        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.navigateMedia(1);
          }
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.navigateMedia(-1);
          }
        });
      }

      show(opener) {
        super.show(opener);
        this.ensureNavigation();
        this.showActiveMedia();
      }

      showActiveMedia() {
        const targetId = this.openedBy?.getAttribute('data-media-id');
        if (!targetId) return;

        const mediaItems = this.mediaItems();
        const activeMedia = mediaItems.find((item) => item.getAttribute('data-media-id') === targetId);
        if (!activeMedia) return;

        mediaItems.forEach((item) => {
          const isActive = item === activeMedia;
          item.classList.toggle('active', isActive);
          item.style.display = isActive ? 'flex' : 'none';
        });

        this.fitActiveMedia(activeMedia);
        this.updateNavigation();
        this.loadDeferredMedia(activeMedia);
      }

      mediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      fitActiveMedia(activeMedia) {
        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        const dialog = this.querySelector('.product-media-modal__dialog');
        const container = this.querySelector('.product-media-modal__content');
        const maxWidth = isMobile ? '90vw' : 'min(78vw, 980px)';
        const maxHeight = isMobile ? '82dvh' : '82vh';

        if (dialog) {
          Object.assign(dialog.style, {
            height: '100dvh',
            minHeight: '100vh',
            padding: isMobile ? '1rem' : '2rem',
            overflow: 'hidden'
          });
        }

        if (container) {
          Object.assign(container.style, {
            position: 'relative',
            width: '100%',
            height: '100dvh',
            maxHeight: '100dvh',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: isMobile ? '5rem 0 1.5rem' : '5rem 7rem 2rem',
            touchAction: 'pan-y',
            cursor: isMobile ? 'default' : 'grab'
          });
        }

        Object.assign(activeMedia.style, {
          display: 'flex',
          width: '100%',
          height: isMobile ? 'calc(100dvh - 6.5rem)' : 'calc(100vh - 7rem)',
          maxWidth: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0',
          overflow: 'hidden'
        });

        const wrappers = [
          activeMedia.querySelector('.global-media-settings'),
          activeMedia.querySelector('.media')
        ].filter(Boolean);

        wrappers.forEach((wrapper) => {
          Object.assign(wrapper.style, {
            width: 'auto',
            height: 'auto',
            maxWidth,
            maxHeight,
            paddingTop: '0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'visible'
          });
        });

        const image = activeMedia.querySelector('img');
        if (image) {
          Object.assign(image.style, {
            position: 'static',
            width: 'auto',
            height: 'auto',
            maxWidth,
            maxHeight,
            objectFit: 'contain',
            objectPosition: 'center center',
            margin: 'auto',
            transform: 'none',
            cursor: isMobile ? 'default' : 'grab'
          });
        }

        activeMedia.querySelectorAll('video, iframe, model-viewer').forEach((media) => {
          Object.assign(media.style, {
            width: 'auto',
            height: 'auto',
            maxWidth,
            maxHeight,
            objectFit: 'contain',
            margin: 'auto'
          });
        });
      }

      ensureNavigation() {
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog || dialog.querySelector('.velora-modal-nav')) return;

        const createButton = (direction, label, symbol) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `velora-modal-nav velora-modal-nav--${direction < 0 ? 'prev' : 'next'}`;
          button.setAttribute('aria-label', label);
          button.textContent = symbol;
          Object.assign(button.style, {
            position: 'fixed',
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: '5',
            width: '4.8rem',
            height: '4.8rem',
            borderRadius: '50%',
            border: '1px solid rgba(18,18,18,.18)',
            background: 'rgba(255,255,255,.94)',
            color: '#121212',
            fontSize: '3.2rem',
            lineHeight: '1',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            boxShadow: '0 2px 12px rgba(0,0,0,.08)'
          });
          button.style[direction < 0 ? 'left' : 'right'] = '2rem';
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.navigateMedia(direction);
          });
          return button;
        };

        dialog.appendChild(createButton(-1, 'Imaginea anterioară', '‹'));
        dialog.appendChild(createButton(1, 'Imaginea următoare', '›'));
      }

      updateNavigation() {
        const buttons = this.querySelectorAll('.velora-modal-nav');
        const showButtons = this.mediaItems().length > 1;
        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        buttons.forEach((button) => {
          button.style.display = showButtons ? 'flex' : 'none';
          button.style.width = isMobile ? '4rem' : '4.8rem';
          button.style.height = isMobile ? '4rem' : '4.8rem';
          button.style.fontSize = isMobile ? '2.7rem' : '3.2rem';
          if (button.classList.contains('velora-modal-nav--prev')) {
            button.style.left = isMobile ? '.6rem' : '2rem';
          } else {
            button.style.right = isMobile ? '.6rem' : '2rem';
          }
        });
      }

      navigateMedia(direction) {
        const mediaItems = this.mediaItems();
        if (mediaItems.length < 2) return;

        const currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        if (currentIndex < 0) return;

        const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;
        const currentMedia = mediaItems[currentIndex];
        const nextMedia = mediaItems[nextIndex];

        currentMedia.classList.remove('active');
        currentMedia.style.display = 'none';

        nextMedia.classList.add('active');
        nextMedia.style.display = 'flex';
        this.fitActiveMedia(nextMedia);
        this.loadDeferredMedia(nextMedia);
      }

      loadDeferredMedia(media) {
        if (media.nodeName === 'DEFERRED-MEDIA') {
          media.loadContent?.();
        }
      }
    }
  );
}
